module.exports = __webpack_public_path__ + "img/coworking_typography.d46a50c8.webp";